/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import "./discourse.css";
import { ColoredDividerThin } from "../ColoredDivider/ColoredDivider";
import Button from "react-bootstrap/Button";
import gauge_easy from "../../assets/images/gauge_easy.png";
import gauge_ok from "../../assets/images/gauge_ok.png";
import gauge_hard from "../../assets/images/gauge_hard.png";
import avatar from "../../assets/images/avatar.png";
import WriteCommentModal from "../Modals/WriteCommentModal";
import Parse from "parse/dist/parse.min.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft,faReply, faThumbsUp } from "@fortawesome/free-solid-svg-icons";

export default function DiscourseForum({
  forumEnabled,
  scrollSize,
  setIsCommentModalOpen,
  idAsNumber,
  langString,
  formattedComments,
  setFormattedComments,
  quotePrefill,
  setQuotePrefill,
}) {
  const handleOpenCommentModal = () => setIsCommentModalOpen(true);
  const currentUserId = localStorage.getItem("userPublisherId");

  // const toggleLike = (commentId) => {
  //   const updated = formattedComments.map((comment) => {
  //     if (comment.id !== commentId) return comment;
  
  //     const hasLiked = comment.likes.includes(currentUserId);
  //     const updatedLikes = hasLiked
  //       ? comment.likes.filter((id) => id !== currentUserId)
  //       : [...comment.likes, currentUserId];
  
  //     // Optional: call backend API here to update likes
  //     // await api.toggleLike({ commentId, userId: currentUserId });
  
  //     return {
  //       ...comment,
  //       likes: updatedLikes,
  //     };
  //   });
  
  //   setFormattedComments(updated);
  // };

  const toggleLike = async (commentId, parseCommentId) => {
    const updated = [...formattedComments];
  
    const commentIndex = updated.findIndex((c) => c.id === commentId);
    const comment = updated[commentIndex];
    const userId = localStorage.getItem("userPublisherId");
  
    if (!userId) {
      console.error("User ID not found in localStorage.");
      alert("Sadly, this platform doesn’t support likes—but your intention to give one is really kind.");

      return;
    }
  
    try {
      const PARSE_APPLICATION_ID = "KsiVc1c1aAFXtHQzTt9dMVrSHHlT13DLPuVyESpG";
      const PARSE_HOST_URL = "https://parseapi.back4app.com/";
      const PARSE_JAVASCRIPT_KEY = "kgicXnMgIxLKHSLzNVhJglZ9BxuM31A4UUPrDgSz";
      Parse.initialize(PARSE_APPLICATION_ID, PARSE_JAVASCRIPT_KEY);
      Parse.serverURL = PARSE_HOST_URL;
      const Comment = Parse.Object.extend("ExtComment");
      const query = new Parse.Query(Comment);
      const parseComment = await query.get(parseCommentId);
  
      const currentLikes = comment.likes || [];
      const isLiked = currentLikes.includes(userId);
  
      if (isLiked) {
        // Remove like
        parseComment.remove("likes", userId);
        comment.likes = currentLikes.filter((id) => id !== userId);
      } else {
        // Add like
        parseComment.addUnique("likes", userId);
        comment.likes = [...currentLikes, userId];
      }
  
      await parseComment.save();
      updated[commentIndex] = comment;
      setFormattedComments(updated);
    } catch (err) {
      console.error("Error toggling like:", err.message);
    }
  };
  
  
  

  const inlineStyle = {
    position: scrollSize ? "sticky" : "",
    bottom: scrollSize ? "25px" : "",
    opacity: scrollSize ? 1 : "",
    transition: scrollSize ? "all 0.5s ease-out" : "",
  };

  // useEffect(() => {
  //   loadComments();
  // }, []);

  // async function loadComments() {
  //   try {
  //     console.log("loadComments");

  //     const Riddle = Parse.Object.extend("ExtRiddle");
  //     const tempQuery = new Parse.Query(Riddle);
  //     tempQuery.equalTo("extIdNumber", idAsNumber);
  //     const results = await tempQuery.find();

  //     const object = results[0];
  //     var relation = object.get("commentRelations2");
  //     var relationQuery = relation.query();
  //     const commentsArray = await relationQuery.find();
  //     setFormattedComments(commentsArray.map((comment, index) => ({
  //       id: index + 1,
  //       avatar: comment.get("profileImage")?.url() || avatar,
  //       username: comment.get("userName") || "Anonymous",
  //       text: comment.get("text") || "",
  //       difficulty: comment.get("rating") || "Unknown",
  //     })) || []);

  //     console.log("Formatted Comments:", formattedComments, idAsNumber);
  //   } catch (error) {
  //     console.error("Comments error:", error);
  //   }
  // }

  // const navigateTo = () => {
  //   const currentDate = new Date();
  //   const dayNumber = currentDate.getDate();
  //   let discourseNumber = dayNumber + 21;

  //   if (discourseNumber === 49) {
  //     discourseNumber = 55;
  //   }

  //   window.open(`https://smartfriends.discourse.group/t/${discourseNumber}`, "_blank");
  // };

  if (!forumEnabled) return null;


  const renderDifficultyIcon = (difficulty) => {
    let iconSrc;
    // console.log(difficulty);
    switch (difficulty) {
      case "Too Easy":
      case 0:
        iconSrc = gauge_easy;
        break;
      case "Good":
      case 1:
        iconSrc = gauge_ok;
        break;
      case "Too Hard":
      case 2:
        iconSrc = gauge_hard;
        break;
      default:
        iconSrc = "";
    }
    return (
      <img
        src={iconSrc}
        alt={difficulty}
        style={{
          width: "40px",
          height: "40px",
          marginLeft: "auto",
        }}
      />
    );
  };

  return (
    <div className="comments" style={{ padding: "0 16px" }}>
      <h2
        className="comments-header"
        style={{
          fontSize: "2rem",
          margin: "16px 0",
          textAlign: "center",
          fontFamily: "Union",
        }}
      >
        {langString === "nl" ? "Reacties" : "Comments"}
      </h2>

      {formattedComments.length === 0 && (
        <p
          style={{
            textAlign: "center",
            fontFamily: "Union",
            fontSize: "1.5rem",
            color: "#999",
            marginTop: "30px",
            marginBottom: "50px",
          }}
        >
          {langString === "nl" ? "Nog geen reacties" : "No comments yet"}
        </p>
      )}

      {!!formattedComments.length &&
        formattedComments.map((item) => (
          
          <div key={item.id}>
            <div
              className="comment-container"
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "space-between",
                padding: "10px 0",
              }}
            >
              <div className="comment-container-content">
                <img
                  src={item.avatar}
                  alt={`${item.username} avatar`}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    border: "2px solid #0056b3", // Blue border
                  }}
                />
                <div style={{ marginLeft: "10px" }}>
                  <p
                    style={{
                      margin: "0",
                      fontWeight: "bold",
                      fontFamily: "Union",
                      fontSize: "1.7rem",
                    }}
                  >
                    {item.username}
                  </p>
                  {item.text && (
                    <p
                      style={{
                        margin: "4px 0 0",
                        fontFamily: "Union",
                        fontSize: "1.5rem",
                      }}
                    >
                      {item.text && (
                        <div style={{ marginTop: "4px" }}>
                          {item.text.split("\n").map((line, idx) =>
                            line.startsWith(">") ? (
                              <p
                                key={idx}
                                style={{
                                  margin: "2px 0",
                                  fontFamily: "Union",
                                  fontSize: "1.4rem",
                                  fontStyle: "italic",
                                  color: "#888",
                                }}
                              >
                                {line.replace(/^>\s?/, "")}
                              </p>
                            ) : (
                              <p
                                key={idx}
                                style={{
                                  margin: "2px 0",
                                  fontFamily: "Union",
                                  fontSize: "1.5rem",
                                  color: "#222",
                                }}
                              >
                                {line}
                              </p>
                            )
                          )}
                        </div>
                      )}
                    </p>
                  )}
                </div>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  alignItems: "start",
                  width: "max-content",
                }}
              >
                {renderDifficultyIcon(item.difficulty)}
              </div>
            </div>
            <div
              title={item.likes.includes(localStorage.userPublisherId) ? "Unlike" : "Like"}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                
                color: item.likes.includes(localStorage.userPublisherId) ? "#51aa6a" : "#0638a0",
                fontFamily: "Union",
                fontSize: "1.4rem",
                marginLeft: "50px",
                marginTop: "15px",
                gap: "6px",
              }}
            >
              <div 
                onClick={() => toggleLike(item.id, item.parseObjectId)}
              >
                <FontAwesomeIcon icon={faThumbsUp} />
                {(
                  <span style={{ marginLeft: "4px", fontSize: "1.2rem", color: item.likes.includes(localStorage.userPublisherId) ? "#51aa6a" : "#0638a0"}}>
                    {item.likes?.length || 0} {item.likes?.length === 1 ? "like" : "likes"}
                  </span>
                )}
              </div>

            <div
              onClick={() => {
                const strippedText = (item.text || "")
                  .split("\n")
                  .filter(line => !line.trim().startsWith(">") && line.trim() !== "")
                  .join(" ")
                  .trim();

                const quoted = `> ${item.username}: ${strippedText}\n\n`;
                setQuotePrefill(quoted);
                setIsCommentModalOpen(true);
              }}
              title={langString === "nl" ? "Reageer" : "Reply"}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#0638a0",
                fontFamily: "Union",
                fontSize: "1.2rem",
                marginLeft: "50px",
                marginTop: "5px",
                gap: "6px",
              }}
            >
              <FontAwesomeIcon icon={faReply}/>
              <span>{langString === "nl" ? "Reageer" : "Reply"}</span>
            </div>
            </div>


            <ColoredDividerThin />
          </div>
        ))}
      {/* 
      <div onClick={navigateTo} style={{ ...inlineStyle, marginTop: "20px" }} className="button">
        <Button style={{ width: "100%", backgroundColor: "#2a00b5", borderColor: "#2a00b5" }}>
          Write a comment
        </Button>
      </div> */}

      <div
        onClick={handleOpenCommentModal}
        
        style={{ ...inlineStyle, marginTop: "20px"}}
        className="button"
        
      
      >
        
        <Button
          style={{
            width: "100%",
            backgroundColor: "#2a00b5",
            borderColor: "#2a00b5",
           
          }}
        >
          {langString === "nl" ? "Schrijf een reactie" : "Write a comment"}
        </Button>
      </div>
    </div>
  );
}
